export const blogPosts = [
  {
    id: 1,
    title: "The Hidden Life of Forest Ecosystems",
    excerpt:
      "Discover the intricate relationships between trees, fungi, and wildlife in our planet's forests.",
    image:
      "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&q=80&w=800",
    author: {
      name: "Emma Wilson",
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200",
      role: "Environmental Scientist",
    },
    date: "Mar 15, 2024",
    readTime: "5 min read",
  },
  {
    id: 2,
    title: "Sustainable Agriculture: A New Approach",
    excerpt:
      "How modern farming techniques are revolutionizing food production while protecting our environment.",
    image:
      "https://images.unsplash.com/photo-1500651230702-0e2d8a49d4ad?auto=format&fit=crop&q=80&w=800",
    author: {
      name: "James Chen",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200",
      role: "Agricultural Expert",
    },
    date: "Mar 12, 2024",
    readTime: "7 min read",
  },
  {
    id: 3,
    title: "Ocean Conservation Success Stories",
    excerpt:
      "Exploring the positive impact of marine protected areas and community-led conservation efforts.",
    image:
      "https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?auto=format&fit=crop&q=80&w=800",
    author: {
      name: "Sarah Martinez",
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200",
      role: "Marine Biologist",
    },
    date: "Mar 10, 2024",
    readTime: "6 min read",
  },
];
